import React from 'react';

export default function InfoPage({onClose}) {
    return (
        <div style={overlayStyle} onClick={onClose}>
            <div style={panelStyle} className="legal-ish-panel" onClick={(e) => e.stopPropagation()}>
                <button onClick={onClose} style={closeButtonStyle} aria-label="Schließen">×</button>
                <div style={topLeftImage}>
                    <img
                        src="/api/get-image.php?name=IMG_3772.jpg"
                        alt="Profielbild"
                    />
                </div>

                <p style={lineStyle}>
                    Gude! Ich bin 27, Architekturstudent und in Wiesbaden geboren. Meinen B.Sc.
                    Architektur an der Hochschule RheinMain (2026) habe ich abgeschlossen und
                    studiere aktuell im Master Architektur an der BUW. Zuvor habe ich ein Studium in Produktentwicklung
                    und Technischem Design an der Frankfurt University of Applied Sciences begonnen,
                    bevor ich zur Architektur gewechselt bin. Meine Schwerpunkte liegen im Wohnungsbau,
                    im kostengünstigen Bauen, im zeitgenössischen Städtebau und in interdisziplinären Themen.
                    Praktische Erfahrung habe ich bei bläser jansen partner, Dortmund gesammelt.
                    Ich arbeite mit Archicad, Vectorworks, Rhino, Revit, SketchUp und der Adobe Creative Cloud.
                </p>
            </div>
        </div>
    );
}

const overlayStyle = {
    position: 'absolute',
    inset: 0,
    background: 'rgb(255,255,255,0.5)',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingTop: '8vh',
    overflowY: 'auto',
    zIndex: 20,
};

const panelStyle = {
    position: 'relative',
    width: '50%',
    height: '95%',
    overflow: 'auto',
    background: 'white',
    border: '1px solid black',
    padding: '48px',
    boxSizing: 'border-box',
    color: '#111',
};

const lineStyle = {
    margin: '10% 0',
    color: '#444',
    fontWeight: 300,
    lineHeight: "1.2",
    textAlign: 'center',
};

const closeButtonStyle = {
    position: 'absolute',
    top: '16px',
    right: '16px',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    border: 'none',
    color: '#111',
    fontSize: '25px',
    lineHeight: 1,
    cursor: 'pointer',
};

const topLeftImage = {
    display: "block",
    margin: "0 auto",
    width: "250px",
    height: "auto",
    marginBottom: "5%"
}
